document.addEventListener("DOMContentLoaded", () => {
  // const markers = [...document.querySelectorAll(".timeline-marker[data-target]")];
  const markers = [...document.querySelectorAll(".timeline-entry-marker[data-target]")];
  const sectionMarkers = [...document.querySelectorAll(".section-marker[data-section-target]")];
  const panels = [...document.querySelectorAll(".timeline-content > .timeline-panel[data-slug]")];
  const sections = [...document.querySelectorAll(".timeline-section[data-slug]")];
  const timelineTester = document.querySelector("#timeline .tester");
  const timelineContent = document.querySelector("#timeline .timeline-content");
  const commitMarkers = [...document.querySelectorAll(".timeline-marker--commit")];
  const mobileTimelineQuery = window.matchMedia("(max-width: 850px)");

  const body = document.body;
  const intro = document.getElementById("intro");
  const feature = document.getElementById("feature");
  const article = document.getElementById("article");
  const timeline = document.getElementById("timeline");
  const footer = document.getElementById("footer");

  // A bare repository URL should begin at the intro. Prevent the browser from
  // restoring a previous timeline scroll position; hash-based deep links keep
  // their normal target behavior.
  if (!window.location.hash) {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }


  const scrollTopTriggers = [
    ...document.querySelectorAll(".btn-top, #site-title")
  ];

  const sectionHashIds = new Set(["intro", "feature", "article", "timeline", "colophon"]);
  let activeSectionId = "";

  scrollTopTriggers.forEach(trigger => {
    trigger.addEventListener("click", event => {
      event.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  });

/*
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
Lightbox
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  
*/

function getActiveSectionHash() {
  const hashSectionId = activeSectionId === "footer" ? "colophon" : activeSectionId;


  const sectionId = sectionHashIds.has(hashSectionId)
    ? hashSectionId
    : "article";

  // return `#${sectionId}`;
  return sectionHashIds.has(sectionId)
    ? `#${sectionId}`
   : "#intro";
}

  function updateSectionHash(sectionId, method = "replaceState") {
  const hashSectionId = sectionId === "footer" ? "colophon" : sectionId;
  if (!sectionHashIds.has(hashSectionId)) return;
  if (
    document.body.classList.contains("lightbox-open") ||
    document.body.classList.contains("lightbox-open")
  ) return;

  const hash = `#${hashSectionId}`;
  if (window.location.hash === hash) return;

  history[method]("", document.title, hash);
}

function syncSectionHashFromBody() {
  const sectionId = [...sectionHashIds].find(id => body.classList.contains(`section-${id}`));
  if (sectionId) updateSectionHash(sectionId);
}

function setActiveSectionHash(method = "pushState") {
  const hash = getActiveSectionHash();
  if (window.location.hash === hash) return;

  history[method]("", document.title, hash);
}



/*
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
Side Nav 
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  
*/

  if (!markers.length || !panels.length || !sections.length) return;

  let introInView = false;
  let featureInView = false;
  let articleInView = false;
  let timelineInView = false;
  let footerInView = false;
  let sectionStateFrame = null;
  let commitScrollFrame = null;

  function updateScrollActiveCommit() {
    commitScrollFrame = null;
    if (!mobileTimelineQuery.matches || !body.classList.contains("timeline-list-in-view")) return;
    if (!timelineContent || !commitMarkers.length) return;

    const rect = timelineContent.getBoundingClientRect();
    const viewportAnchor = window.innerHeight * 0.45;
    const progress = Math.min(1, Math.max(0, (viewportAnchor - rect.top) / Math.max(rect.height, 1)));
    const activeIndex = Math.round(progress * (commitMarkers.length - 1));

    commitMarkers.forEach((marker, index) => {
      marker.classList.toggle("scroll-active", index === activeIndex);
    });
  }

  function scheduleScrollActiveCommit() {
    if (commitScrollFrame) return;
    commitScrollFrame = window.requestAnimationFrame(updateScrollActiveCommit);
  }

  function setActive(slug) {
    markers.forEach(marker => {
      marker.classList.toggle("active", marker.dataset.target === slug);
      marker.classList.remove("show-all");
    });

    panels.forEach(panel => {
      panel.classList.toggle("active", panel.dataset.slug === slug);
      panel.classList.remove("show-all");
    });
  }

  function clearActive() {
    markers.forEach(marker => marker.classList.remove("active"));
    panels.forEach(panel => panel.classList.remove("active"));
  }

  function showAllTimeline() {
    markers.forEach(marker => {
      marker.classList.remove("active");
      marker.classList.add("show-all");
    });

    panels.forEach(panel => {
      panel.classList.remove("active");
      panel.classList.add("show-all");
    });
  }

  function clearShowAllTimeline() {
    markers.forEach(marker => marker.classList.remove("show-all"));
    panels.forEach(panel => panel.classList.remove("show-all"));
  }

  function setSectionNavActive(sectionId) {
    sectionMarkers.forEach(marker => {
      marker.classList.toggle(
        "active",
        marker.dataset.sectionTarget === sectionId
      );
    });

    body.classList.toggle("timeline-expanded", sectionId === "timeline");
    body.classList.toggle("timeline-folded", sectionId !== "timeline");

    if (sectionId !== "timeline") {
      clearActive();
    }
  }


  function setMode(mode) {
    const sectionId = mode.replace("section-", "");

    if (body.classList.contains(mode)) {
      activeSectionId = sectionId;
      updateSectionHash(sectionId);
      return;
    }

    body.classList.remove("section-intro", "section-feature", "section-article", "section-timeline", "section-footer");
    if (mode) body.classList.add(mode);

    activeSectionId = sectionId;
    setSectionNavActive(sectionId);
    updateSectionHash(sectionId);
  }

  function isSectionCurrent(element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    const targetY = window.innerHeight * 0.45;

    return rect.top <= targetY && rect.bottom > targetY;
  }

  function updateFooterInView() {
    if (!footer) {
      footerInView = false;
      return false;
    }

    const rect = footer.getBoundingClientRect();
    const enterFooter = rect.top < window.innerHeight && rect.bottom > 0;
    const stayInFooter = rect.top < window.innerHeight + 96 && rect.bottom > -96;

    footerInView = footerInView ? stayInFooter : enterFooter;
    return footerInView;
  }

  function resolveArticleTimelineMode() {
    sectionStateFrame = null;

    if (introInView || featureInView) return;

    if (updateFooterInView()) {
      setMode("section-footer");
      return;
    }

    timelineInView = isSectionCurrent(timeline);

    if (isSectionCurrent(article)) {
      setMode("section-article");
      showAllTimeline();
      clearActive();
      return;
    }

    if (timelineInView) {
      setMode("section-timeline");
    }
  }

  function scheduleArticleTimelineMode() {
    if (sectionStateFrame) return;
    sectionStateFrame = window.requestAnimationFrame(() => {
      resolveArticleTimelineMode();
      syncSectionHashFromBody();
    });
  }

  function getFirstTimelineSlug() {
    return sections[0]?.dataset.slug;
  }
  sectionMarkers.forEach(marker => {
  marker.addEventListener("click", event => {
    event.preventDefault();

    const id = marker.dataset.sectionTarget;
    const target = document.getElementById(id);

    if (!target) return;

    if (id === "timeline") {
      setMode("section-timeline");

      const firstSlug = getFirstTimelineSlug();
      if (firstSlug) {
        setActive(firstSlug);
        scrollToSlug(firstSlug);
      }

      return;
    }

    window.scrollTo({
      top: target.offsetTop - 80,
      behavior: "smooth"
    });
  });
});

  // function scrollToSlug(slug) {
  //   const section = document.getElementById(slug);
  //   if (!section) return;

  //   window.scrollTo({
  //     top: section.offsetTop - 120,
  //     behavior: "smooth"
  //   });

  // }
  function scrollToSlug(slug, behavior = "smooth") {
  const section = document.querySelector(`.timeline-section[data-slug="${slug}"]`);
  if (!section) return;

  const top =
    section.getBoundingClientRect().top +
    window.scrollY -
    window.innerHeight * 0.35;

  window.scrollTo({
    top,
    behavior
  });
}

  // markers.forEach(marker => {
  //   marker.addEventListener("click", () => {
  //     scrollToSlug(marker.dataset.target);
  //   });

  //   marker.addEventListener("keydown", (event) => {
  //     if (event.key === "Enter" || event.key === " ") {
  //       event.preventDefault();
  //       scrollToSlug(marker.dataset.target);
  //     }
  //   });
  // });
  
  markers.forEach(marker => {
  marker.addEventListener("click", event => {
    event.preventDefault();
    event.stopPropagation();

    setMode("section-timeline");
    setActive(marker.dataset.target);
    scrollToSlug(marker.dataset.target);
  });

  marker.addEventListener("keydown", event => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();

      setMode("section-timeline");
      setActive(marker.dataset.target);
      scrollToSlug(marker.dataset.target);
    }
  });
});

  const sectionObserver = new IntersectionObserver(
    entries => {
      // Only run timeline logic outside the intro, feature, and article sections.
      if (introInView || featureInView || updateFooterInView() || isSectionCurrent(article)) return;

      setMode("section-timeline");


      const visible = entries
        .filter(entry => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (!visible.length) return;

      clearShowAllTimeline();
      setActive(visible[0].target.dataset.slug);
    },
    {
      rootMargin: "-35% 0px -35% 0px",
      threshold: [0.25, 0.5, 0.75]
    }
  );

  sections.forEach(section => sectionObserver.observe(section));

  if (timeline) {
    const timelineObserver = new IntersectionObserver(
      entries => {
        if (updateFooterInView()) return;

        timelineInView = entries[0].isIntersecting && isSectionCurrent(timeline);

        if (timelineInView && !introInView && !featureInView && !footerInView) {
          setMode("section-timeline");
        }
      },
      { threshold: 0.01 }
    );

    timelineObserver.observe(timeline);
  }

  if (timelineContent) {
    const timelineListObserver = new IntersectionObserver(
      entries => {
        const isVisible = entries[0].isIntersecting;
        body.classList.toggle("timeline-list-in-view", isVisible);

        if (isVisible) {
          scheduleScrollActiveCommit();
        } else {
          commitMarkers.forEach(marker => marker.classList.remove("scroll-active"));
        }
      },
      { threshold: 0.01 }
    );

    timelineListObserver.observe(timelineContent);
  }

  if (timelineTester) {
    const timelineTesterObserver = new IntersectionObserver(
      entries => {
        body.classList.toggle("timeline-tester-in-view", entries[0].isIntersecting);
      },
      { threshold: 0.01 }
    );

    timelineTesterObserver.observe(timelineTester);
  }

  window.addEventListener("scroll", scheduleArticleTimelineMode, { passive: true });
  window.addEventListener("scroll", scheduleScrollActiveCommit, { passive: true });
  window.addEventListener("resize", scheduleArticleTimelineMode);
  window.addEventListener("resize", scheduleScrollActiveCommit);
  mobileTimelineQuery.addEventListener("change", () => {
    if (!mobileTimelineQuery.matches) {
      body.classList.remove("timeline-list-in-view");
      commitMarkers.forEach(marker => marker.classList.remove("scroll-active"));
    }
  });

  if (intro) {
    const introObserver = new IntersectionObserver(
      entries => {
        introInView = entries[0].isIntersecting;
        body.classList.toggle("section-intro", introInView);

        if (introInView) {
          setMode("section-intro");
          clearShowAllTimeline();
          clearActive();
        } else {
          body.classList.remove("section-intro");
          scheduleArticleTimelineMode();
        }

      },
      { threshold: 0.01 }
    );

    introObserver.observe(intro);
  }



if (feature) {
  const featureObserver = new IntersectionObserver(
    entries => {
      featureInView = entries[0].isIntersecting;

      if (featureInView) {
        setMode("section-feature");
        showAllTimeline();
        clearActive();
      } else {
        clearShowAllTimeline();

        if (window.featureAnimations) {
          window.featureAnimations.stopAll();
        }

        scheduleArticleTimelineMode();
      }
    },
    { threshold: 0.01 }
  );

  featureObserver.observe(feature);
}
if (article) {
  const articleObserver = new IntersectionObserver(
    entries => {
      articleInView = entries[0].isIntersecting;

      if (articleInView && isSectionCurrent(article)) {
        setMode("section-article");
        showAllTimeline();
        clearActive();
      } else {
        clearShowAllTimeline();
      }
    },
    { threshold: 0.01 }
  );

  articleObserver.observe(article);
}

if (footer) {
  const footerObserver = new IntersectionObserver(
    () => {
      if (updateFooterInView()) {
        setMode("section-footer");
        return;
      }

      scheduleArticleTimelineMode();
    },
    { threshold: 0.01 }
  );

  footerObserver.observe(footer);
}

function openSectionFromHash() {
  const hashId = window.location.hash.replace("#", "");
  const timelineMarker = markers.find(marker => marker.dataset.target === hashId);

  if (timelineMarker) {
    setMode("section-timeline");
    setActive(hashId);
    requestAnimationFrame(() => scrollToSlug(hashId, "auto"));
    return;
  }

  const sectionId = hashId;
  if (!sectionHashIds.has(sectionId)) return;
  const targetId = sectionId === "colophon" ? "footer" : sectionId;
  const target = document.getElementById(targetId);

  if (!target) return;

  setMode(`section-${targetId}`);

  window.scrollTo({
    top: targetId === "timeline" ? target.offsetTop : target.offsetTop - 80,
    behavior: "auto"
  });
}


function handleHashState() {
  openSectionFromHash();
}

window.addEventListener("hashchange", handleHashState);
window.addEventListener("popstate", handleHashState);

handleHashState();



 

});
